module.exports = {"name":"ng-dro-uaa","version":"1.0.1","description":"Modulo User Account and Authentication per il framework ngDro","main":"module.js","repository":{"type":"git","url":"https://git.dromedian.it/g.ventrella/ngDro-uaa.git"},"author":"","license":"ISC","dependencies":{"angular-ui-tree":"^2.22.6","isteven-angular-multiselect":"^4.0.0","js-base64":"^2.3.2","ng-img-crop":"^0.2.0","ng-infinite-scroll":"^1.3.0","ng-quill":"^3.5.1","ng-sanitize":"0.0.2","quill":"^1.3.7"}}


//////////////////
// WEBPACK FOOTER
// ./src/modules/ngDro-uaa/package.json
// module id = 393
// module chunks = 0